import { endOfDay } from 'date-fns';
import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';
import { atomWithDefault, loadable } from 'jotai/utils';
import { Temporal } from 'temporal-polyfill';
import { IPageConfigDataModel } from '../../../data-models/page-config.data-model';
import { fetchPageConfig } from '../../../services/queries/MaggieViewQueries';
import { TemporalPlainDateFromJsDate } from '../../../util/date-utilts';
import { selectedViewIdPFJ } from './ViewStateJ';

type PageConfigValue = IPageConfigDataModel | Promise<IPageConfigDataModel>;

/**
 * Default fetches the user's portfolio page config on first subscribe.
 * Consumers using `useAtomValue` will suspend on first read; use
 * {@link pageConfigPFLoadableJ} for non-suspending callers.
 */
export const pageConfigPFJ = atomWithDefault<PageConfigValue>(async () => await fetchPageConfig());

export const pageConfigPFLoadableJ = loadable(pageConfigPFJ);

/**
 * Keyed by viewId; the value is the user's selected as-of date for that view.
 */
export const selectedDateByViewPFJ = atomFamily((_viewId: number) => atom<Date>(defaultViewDate()));

/**
 * Derived atom: returns the selected date for the currently selected view.
 */
export const selectedViewDatePFJ = atom((get): Date => {
  const selectedViewId = get(selectedViewIdPFJ);
  return get(selectedDateByViewPFJ(selectedViewId));
});

export const selectedViewTemporalDatePFJ = atom((get): Temporal.PlainDate => {
  return TemporalPlainDateFromJsDate(get(selectedViewDatePFJ));
});

export function defaultViewDate() {
  return endOfDay(new Date());
}
